export enum NotificationStatus {
  Success = "Success",
  Error = "Error",
  Info = "Info",
  Inherit = "Inherit",
}
